import { render, staticRenderFns } from "./ConfigurarProva.vue?vue&type=template&id=7f4b3387&scoped=true&"
import script from "./ConfigurarProva.vue?vue&type=script&lang=js&"
export * from "./ConfigurarProva.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurarProva.vue?vue&type=style&index=0&id=7f4b3387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b3387",
  null
  
)

export default component.exports